import type { SecureProject } from "features/secureUploads/secureUploads";

import ManageProjectAccessDialog from "./ManageProjectAccessDialog";
import ProjectFormDialog from "./ProjectFormDialog";
import {
  CloseProjectDialog,
  DeleteProjectDialog,
  ReopenProjectDialog,
} from "./ProjectStatusDialogs";

/** What a page asked to do with a project. */
export type ProjectAction =
  | { kind: "create"; clientId: number | null }
  | {
      kind: "edit" | "access" | "close" | "reopen" | "delete";
      project: SecureProject;
    };

interface ProjectDialogsProps {
  action: ProjectAction | null;
  onClose: () => void;
  onSaved?: (project: SecureProject) => void;
  onDeleted?: (project: SecureProject) => void;
}

/** Every project dialog behind one switch, for the client and project pages. */
export default function ProjectDialogs({
  action,
  onClose,
  onSaved,
  onDeleted,
}: ProjectDialogsProps) {
  const project = action && action.kind !== "create" ? action.project : null;
  const is = (kind: ProjectAction["kind"]) => action?.kind === kind;
  return (
    <>
      <ProjectFormDialog
        open={is("create")}
        mode="create"
        clientId={action?.kind === "create" ? action.clientId : null}
        onClose={onClose}
        onSaved={onSaved}
      />
      <ProjectFormDialog
        open={is("edit")}
        mode="edit"
        project={project ?? undefined}
        onClose={onClose}
        onSaved={onSaved}
      />
      <ManageProjectAccessDialog
        open={is("access")}
        project={project}
        onClose={onClose}
      />
      <CloseProjectDialog
        open={is("close")}
        project={project}
        onClose={onClose}
      />
      <ReopenProjectDialog
        open={is("reopen")}
        project={project}
        onClose={onClose}
      />
      <DeleteProjectDialog
        open={is("delete")}
        project={project}
        onClose={onClose}
        onDeleted={onDeleted}
      />
    </>
  );
}
